import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useGetSeoSettingsQuery } from '../../features/api/apiSlice';

const SEO = ({ title, description, keywords, ogTitle, ogDescription, ogImage, canonicalUrl, schema }) => {
  const { data: globalSeoSettings } = useGetSeoSettingsQuery();

  const defaultTitle = globalSeoSettings?.default_title || 'HireBroker - Real Estate in Uganda & Africa';
  const defaultDescription = globalSeoSettings?.default_description || 'Find properties, hostels, and hotels across Uganda and Africa. Your trusted partner in real estate.';
  const defaultKeywords = globalSeoSettings?.default_keywords || 'real estate uganda, property africa, homes for sale uganda, apartments kampala, land for sale africa, commercial property uganda, hirebroker, uganda property market, africa real estate investment';

  const pageTitle = title ? `${title} | HireBroker` : defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords || defaultKeywords;
  const pageOgTitle = ogTitle || pageTitle;
  const pageOgDescription = ogDescription || pageDescription;
  const pageOgImage = ogImage || globalSeoSettings?.default_og_image; // Assuming a default OG image from settings

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl || window.location.href} />
      <meta property="og:title" content={pageOgTitle} />
      <meta property="og:description" content={pageOgDescription} />
      {pageOgImage && <meta property="og:image" content={pageOgImage} />}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl || window.location.href} />
      <meta property="twitter:title" content={pageOgTitle} />
      <meta property="twitter:description" content={pageOgDescription} />
      {pageOgImage && <meta property="twitter:image" content={pageOgImage} />}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
